var exports = {
  "kL": "xa15a2ab7--25ab7e--container",
  "vR": "xa15a2ab7--25ab7e--tabs",
  "Mf": "xa15a2ab7--25ab7e--tab",
  "KD": "xa15a2ab7--25ab7e--onmap",
  "qR": "xa15a2ab7--25ab7e--similar",
  "vu": "xa15a2ab7--25ab7e--active",
  "i0": "xa15a2ab7--25ab7e--special",
  "Y_": "xa15a2ab7--25ab7e--special-promo",
};

module.exports = exports;
